/* BOGO deals: the deal-page builder and the one-BOGO-per-order rule.

   Deal pages (sections/elevana-bogo-deal.liquid): pick a strain for each step, then one click adds
   those variants with _bogo line properties and puts the deal's code on the cart via
   /cart/update.js {discount}. The Shopify discount code is what prices the deal at checkout;
   products added from product pages carry no code, so they never get it.

   Every page: after any bag edit (elevana-cart.js fires 'elevana:cart-changed') sync() removes a
   BOGO code once no BOGO lines are left, and puts it back if the lines are there but the code
   went missing. A BOGO code never shares the cart with another code (they don't combine). */
(function () {
  var BOGO = /^BOGO-/i;

  function req(url, body) {
    var opts = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }
      : { headers: { 'Accept': 'application/json' } };
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) { var e = new Error(d.description || d.message || 'Something went wrong'); e.status = r.status; throw e; }
        return d;
      });
    });
  }
  function getCart() { return req('/cart.js'); }
  function codesOf(cart) { return (cart.discount_codes || []).map(function (c) { return c.code; }); }
  function bogoLines(cart) { return (cart.items || []).filter(function (i) { return i.properties && i.properties._bogo; }); }
  function refreshBag(open) {
    if (!window.ElevanaCart) return Promise.resolve();
    return window.ElevanaCart.refresh().then(function () { if (open) window.ElevanaCart.open(); });
  }

  function sync() {
    return getCart().then(function (cart) {
      var lines = bogoLines(cart), codes = codesOf(cart);
      var want = lines.length ? String(lines[0].properties._bogo_code || '') : '';
      var have = codes.filter(function (c) { return BOGO.test(c); });
      if (!want && !have.length) return cart;
      if (want && have.length === 1 && have[0].toUpperCase() === want.toUpperCase()) return cart;
      var others = codes.filter(function (c) { return !BOGO.test(c); });  /* keep non-BOGO codes, e.g. the cart deal */
      var next = want ? [want].concat(others) : others;
      return req('/cart/update.js', { discount: next.join(',') }).then(function (c) { return refreshBag(false).then(function () { return c; }); });
    }).catch(function () {});
  }

  window.ElevanaBogo = { sync: sync };

  /* ---------------- deal page ---------------- */
  var cfgEl = document.getElementById('elb-config');
  var root = document.querySelector('[data-elb]');
  if (!cfgEl || !root) { document.addEventListener('elevana:cart-changed', sync); return; }

  var cfg = JSON.parse(cfgEl.textContent);
  var slots = [].slice.call(root.querySelectorAll('[data-elb-slot]'));
  var picks = slots.map(function () { return null; });
  var sum = root.querySelector('[data-elb-sum]');
  var linesEl = sum.querySelector('[data-elb-lines]'), wasEl = sum.querySelector('[data-elb-was]'), nowEl = sum.querySelector('[data-elb-now]');
  var saveEl = sum.querySelector('[data-elb-save]'), warnEl = sum.querySelector('[data-elb-warn]'), needEl = sum.querySelector('[data-elb-need]');
  var btn = sum.querySelector('[data-elb-add]');
  var inBag = null, otherKeys = [], otherName = '', errMsg = '';

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function mapOf(slot) { try { return JSON.parse(slot.querySelector('[data-elb-map]').textContent); } catch (e) { return {}; } }
  function fromBtn(b) {
    return { id: +b.dataset.id, handle: b.dataset.handle, price: +b.dataset.price, name: b.dataset.name, size: b.dataset.size, img: b.dataset.img };
  }

  /* a "same strain" step follows step 1; strains whose free size is sold out can't be picked in step 1 */
  slots.forEach(function (s) {
    if (!s.hasAttribute('data-same') || !slots[0]) return;
    var map = mapOf(s);
    [].forEach.call(slots[0].querySelectorAll('.elb-opt'), function (b) {
      var e = map[b.dataset.handle];
      if (!b.disabled && !(e && e.available)) {
        b.disabled = true;
        var out = b.querySelector('.elb-opt-out');
        if (out) { out.textContent = 'Free ' + (e ? e.size : 'size') + ' sold out'; out.hidden = false; }
      }
    });
  });

  function followFirst() {
    slots.forEach(function (s, i) {
      if (!s.hasAttribute('data-same')) return;
      var view = s.querySelector('[data-elb-same-view]'), im = view.querySelector('.elb-same-im'), t = view.querySelector('.elb-same-t');
      if (!view.dataset.def) view.dataset.def = t.textContent;
      var first = picks[0], e = first && mapOf(s)[first.handle];
      picks[i] = e && e.available ? { id: e.id, handle: first.handle, price: e.price, name: e.name, size: e.size, img: e.img } : null;
      if (!first) { im.innerHTML = ''; t.textContent = view.dataset.def; view.classList.remove('is-set'); return; }
      if (picks[i]) {
        im.innerHTML = e.img ? '<img src="' + esc(e.img) + '" alt="">' : '';
        t.innerHTML = '<b>' + esc(e.name) + '</b> &middot; ' + esc(e.size) + ' added free';
        view.classList.add('is-set');
      } else {
        im.innerHTML = '';
        t.textContent = 'No free size of ' + first.name + ' left right now. Pick another strain above.';
        view.classList.remove('is-set');
      }
    });
  }

  function render() {
    followFirst();
    var was = 0, now = 0, done = true, html = '';
    slots.forEach(function (s, i) {
      var p = picks[i], off = +s.dataset.off || 0, label = s.dataset.label;
      if (!p) { done = false; html += '<li class="is-empty"><span>' + esc(label) + '</span><em>Not chosen yet</em></li>'; return; }
      var paid = Math.round(p.price * (100 - off) / 100);
      was += p.price; now += paid;
      html += '<li><span>' + esc(label) + '</span><b>' + esc(p.name) + ' <small>' + esc(p.size) + '</small></b><i>' +
        (off ? '<s>' + money(p.price) + '</s>' : '') + (paid ? money(paid) : 'FREE') + '</i></li>';
    });
    linesEl.innerHTML = html;
    wasEl.textContent = money(was);
    nowEl.textContent = money(now);
    saveEl.hidden = !(was > now);
    saveEl.textContent = 'You save ' + money(was - now);

    var msg = errMsg;
    if (!msg && inBag === 'same') msg = 'The ' + cfg.name + ' deal is already in your bag. It\'s one BOGO per order.';
    if (!msg && inBag === 'other') msg = 'Your bag already has the ' + otherName + ' deal. It\'s one BOGO per order, so adding this deal replaces that one.';
    warnEl.textContent = msg;
    warnEl.hidden = !msg;

    if (inBag === 'same') {
      btn.disabled = false; btn.textContent = 'View bag'; needEl.hidden = true;
    } else {
      btn.disabled = !done;
      btn.textContent = inBag === 'other' ? 'Swap for this deal' : btn.getAttribute('data-label');
      needEl.hidden = done;
    }
  }

  function inspect() {
    return getCart().then(function (cart) {
      var lines = bogoLines(cart);
      otherKeys = []; otherName = '';
      if (!lines.length) inBag = null;
      else if (lines[0].properties._bogo === cfg.deal) inBag = 'same';
      else { inBag = 'other'; otherName = lines[0].properties._bogo_name || 'another'; otherKeys = lines.map(function (l) { return l.key; }); }
      render();
    }).catch(function () { render(); });
  }

  function add() {
    if (btn.dataset.busy) return;
    if (inBag === 'same') { if (window.ElevanaCart) window.ElevanaCart.open(); else window.location.href = '/cart'; return; }
    if (picks.some(function (p) { return !p; })) return;
    var code = (cfg.codes && cfg.codes[picks[0].handle]) || cfg.code;
    if (!code) { errMsg = 'This deal isn\'t switched on yet.'; render(); return; }
    errMsg = '';
    btn.dataset.busy = '1'; btn.classList.add('is-busy');
    var props = { _bogo: cfg.deal, _bogo_name: cfg.name, _bogo_code: code };
    var items = picks.map(function (p) { return { id: p.id, quantity: 1, properties: props }; });
    var chain = Promise.resolve();
    if (otherKeys.length) {
      var up = {}; otherKeys.forEach(function (k) { up[k] = 0; });
      chain = req('/cart/update.js', { updates: up });
    }
    chain
      .then(function () { return req('/cart/add.js', { items: items }); })
      .then(function () { return getCart(); })
      .then(function (c) { var others = codesOf(c).filter(function (x) { return !BOGO.test(x); }); return req('/cart/update.js', { discount: [code].concat(others).join(',') }); })
      .then(function (cart) {
        var dc = (cart.discount_codes || []).filter(function (c) { return String(c.code).toUpperCase() === code.toUpperCase(); })[0];
        if (dc && dc.applicable === false) errMsg = 'The deal is in your bag, but the deal price couldn\'t be applied. Check your bag before checkout.';
        return inspect().then(function () { return refreshBag(true); });
      })
      .catch(function (e) {
        errMsg = (e && e.status === 422 && e.message) ? e.message : 'Couldn\'t add the deal. Please try again.';
        return inspect();
      })
      .finally(function () { delete btn.dataset.busy; btn.classList.remove('is-busy'); });
  }

  root.addEventListener('click', function (e) {
    var o = e.target.closest('.elb-opt');
    if (!o || o.disabled) return;
    var s = o.closest('[data-elb-slot]'), i = slots.indexOf(s);
    [].forEach.call(s.querySelectorAll('.elb-opt'), function (b) { b.setAttribute('aria-checked', b === o ? 'true' : 'false'); });
    picks[i] = fromBtn(o);
    errMsg = '';
    render();
  });
  btn.addEventListener('click', add);
  document.addEventListener('elevana:cart-changed', function () { sync().then(inspect); });

  /* a step with only one thing to choose is chosen for you (e.g. MAC 1) */
  slots.forEach(function (s) {
    if (s.hasAttribute('data-same')) return;
    var ok = [].filter.call(s.querySelectorAll('.elb-opt'), function (b) { return !b.disabled; });
    if (ok.length === 1) ok[0].click();
  });
  render();
  inspect();
})();
